//      
import { invariant } from '../invariant';

export default ()                  => {
  const body                   = document.body;
  invariant(body, 'Cannot find document.body');
  return body;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/get-body-element.js